<template>
    <div class="single-calendar">
        <ValidateInput
            class="single-date-input"
            :placeholder="inputPlaceHolder"
            :initValue="inputValue"
            @inputChange="inputChange"
            v-show="!noInput"
            @inputFoucs="inputFocus"
            :noInitBorder="noInitBorder"
            :hasRadius="hasRadius"
            :noIcon="noIcon"
        />
        <CalendarPopup class="single-calendar-popup" @monthSwitch="monthSwitch" :style="popupStyle" v-if="showPopup">
            <CalendarMonth
                class="calendar-month"
                :monthDate="monthDate"
                @dateClick="dateClickHandler"
                :selectedRange="selectedRange"
                :disableRanges="disabledRanges"
            />
            <CalendarBottom class="calendar-time" :hour="hours" :min="mins" @confirm="confirmClick" @cancel="cancelClick" />
        </CalendarPopup>
    </div>
</template>

<script>
import CalendarPopup from "./CalendarPopup";
import CalendarMonth from "./CalendarMonth";
import CalendarBottom from "./CalendarBottom";
import ValidateInput from "@/views/zhiji/bComponents/inputs/ValidateInput";

export default {
    name: "SingleCalendar",
    components: {
        CalendarPopup,
        CalendarMonth,
        CalendarBottom,
        ValidateInput
    },
    // value: Date || Date Array, disableRanges: [{start:Date, end:Date},...], ..., config: {placeHolder, dateFormat, position, noInput, noInitBorder, hasRadius}
    props: ["value", "disableRanges", "config", "disabled"],
    data() {
        return {
            inputPlaceHolder: (this.config && this.config.placeHolder) || "YYYY/MM/DD hh:mm",
            noIcon: (this.config && this.config.noIcon) || false,
            noInput: (this.config && this.config.noInput) || false,
            noInitBorder: (this.config && this.config.noInitBorder) || false,
            hasRadius: (this.config && this.config.hasRadius) || false,
            inputValue: this.getDisplayValue(this.value),
            showPopup: false,
            selectedRange: this.getSelectedRange(this.value),
            disabledRanges: this.getDisabledRanges(),
            monthDate: this.getMonthDate(),
            selectedValue: this.value || new Date()
        };
    },
    computed: {
        popupStyle() {
            let position = this.config && this.config.position;

            if (position === "left") {
                return {
                    right: "auto",
                    left: 0
                };
            } else if (position === "leftTop") {
                return {
                    right: 0,
                    bottom: "41px",
                    top: "auto"
                };
            } else if (position === "rightTop") {
                return {
                    right: "auto",
                    left: 0,
                    bottom: "41px",
                    top: "auto"
                };
            } else if (position === "right") {
                return {
                    right: 0,
                    left: "auto"
                };
            }

            return {};
        },
        hours() {
            return this.zhiji.dateFormat(this.selectedValue, "hh");
        },
        mins() {
            return this.zhiji.dateFormat(this.selectedValue, "mm");
        }
    },
    watch: {
        value(newVal) {
            this.selectedValue = newVal || new Date();
            this.inputValue = this.getDisplayValue(newVal);
            this.selectedRange = this.getSelectedRange(newVal);
            this.preMonthDate = this.getMonthDate();
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        inputFocus() {
            if (this.disabled) {
                return;
            }

            this.showPopup = true;
        },
        hidePopup() {
            this.showPopup = false;
        },
        dateClickHandler(date) {
            if (this.selectedValue) {
                let isEqual = this.zhiji.dateFormat(this.selectedValue, "YYYYMMDD") == this.zhiji.dateFormat(date, "YYYYMMDD");
                if (isEqual) {
                    return;
                }
            }

            this.selectedValue = date;
            this.selectedRange = this.getSelectedRange(this.selectedValue);
        },
        handlerSelect(timeStr) {
            let hours = parseInt(timeStr.split(":")[0]);
            let mins = parseInt(timeStr.split(":")[1]);
            this.selectedValue.setHours(hours);
            this.selectedValue.setMinutes(mins);

            this.$emit("dateSelect", this.selectedValue);

            this.inputValue = this.getDisplayValue(this.selectedValue);
            this.hidePopup();
            return;
        },
        getFormat() {
            return (this.config && this.config.dateFormat) || "YYYY-MM-DD hh:mm";
        },
        getDisplayValue(value) {
            if (!value) {
                return "";
            }

            return this.zhiji.dateFormat(value, this.getFormat());
        },
        getMonthDate() {
            return this.value || new Date();
        },
        getSelectedRange(value) {
            let ret = {};
            if (value && value.length != null) {
                ret.start = value.length ? value[0] : null;
                ret.end = value.length > 1 ? value[1] : null;
            } else if (value) {
                ret.start = value;
                ret.end = value;
            }

            return ret;
        },
        getDisabledRanges() {
            if (this.disableRanges) {
                return this.disableRanges;
            }

            return null;
        },
        monthSwitch(direct) {
            let newMonthDate;

            newMonthDate = this.monthDate;
            newMonthDate = new Date(newMonthDate.getTime());

            if (direct == "pre") {
                newMonthDate.setDate(1);
                newMonthDate = new Date(newMonthDate.getTime() - 24 * 60 * 60 * 1000);
            } else {
                newMonthDate.setMonth(newMonthDate.getMonth() + 1);
            }

            this.monthDate = newMonthDate;
        },
        confirmClick(timeStr) {
            this.handlerSelect(timeStr);
        },
        cancelClick() {
            this.hidePopup();
        },
        deleteClick() {
            this.$emit("dateSelect", "");
        },
        inputChange(inputVal) {
            if (!inputVal) {
                this.$emit("dateSelect", "");
            }
        },
        windowClick(event) {
            if (this.showPopup && this.zhiji.isClickOuter(event, "single-calendar")) {
                this.hidePopup();
            }
        }
    }
};
</script>

<style lang="less" scoped>
.single-calendar {
    width: 240px;
    height: 100%;
    position: relative;

    .single-date-input {
        width: 100%;
        height: 100%;
    }

    .single-calendar-popup {
        display: inline-block;
    }

    .calendar-next {
        padding-left: 0;
    }
}
</style>
